import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export const BENEFIT_ERROR_RETRY = 'RETRY';
export const BENEFIT_ERROR_CANCEL = 'CANCEL';

@Component({
  selector: 'app-bags-benefit-error-modal',
  templateUrl: './bags-benefit-error-modal.component.html',
  styleUrls: ['./bags-benefit-error-modal.component.scss'],
  standalone: false,
})
export class BagsBenefitErrorModalComponent {
  @Input() bankNameKey = '';

  constructor(public modal: NgbActiveModal) {}

  onRetry() {
    this.modal.close(BENEFIT_ERROR_RETRY);
  }

  onCancel() {
    this.modal.close(BENEFIT_ERROR_CANCEL);
  }
}
